import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ReengageAuditComponent } from './reengage-audit.component';

const routes: Routes = [
  {
    path: '',
    component: ReengageAuditComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReengageAuditRoutingModule {}
